<template>
  <div class="notification-container">
    <head-title class="head-title">
      <div class="top-title">
        <slot name="title"/>
      </div>
      <router-link to="/notifications">
        <icon-base class="icon-wrap" red>
          <icon-arrow-btn />
        </icon-base>
      </router-link>
    </head-title>

    <div class="notification__body">
      <div class="notification-item" v-for="notification in notificationsHistoryList" :key="notification.id">
        <div class="notification-item__text">{{notification.text}}</div>
        <div class="notification-item__time">{{notification.createdAt | formatDate}}</div>
        <div class="notification-item__channel">{{notification.channels | generateChannelsList}}</div>
      </div>
      <div class="all-entries" :class="{'all-entries_empty': !notificationsHistoryTotalCount}">
        <span v-if="notificationsHistoryTotalCount">There are <router-link to="/notifications" class="all-entries__link">{{notificationsHistoryTotalCount | formatCountEntries}}</router-link></span>
        <span v-else>There are no entries yet...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { formatDate, generateChannelsList, formatCountEntries } from 'src/utils/helpers';
import { IconArrowBtn } from 'Icons';

export default {
  data: () => ({
  }),
  components: {
    IconArrowBtn,
  },
  methods: {
    ...mapActions('userData', [
      'updateNotificationsHistory',
    ]),
  },
  filters: {
    formatDate,
    generateChannelsList,
    formatCountEntries,
  },
  computed: {
    ...mapState('userData', [
      'notificationsHistoryList',
      'notificationsHistoryTotalCount',
    ]),
  },
  created() {
    this.updateNotificationsHistory(4);
  },
};
</script>

<style lang="scss" scoped>
.notification-container {
  margin: 0 90px;
  width: 550px;
  border-radius: 5px;
  background: $white-color2;
  padding: 27px 0 0;
  position: relative;
}
.notification-item {
  padding: 25px 30px 29px;
  border-bottom: 1px solid $grey-color3;
  &__text {
    margin-bottom: 12px;
    @include font(13px, $black-color1, 500);
    line-height: 20px;
  }
  &__time {
    display: inline-block;
    @include font(12px, $grey-color9, 500);
  }
  &__channel {
    display: inline-block;
    @include font(12px, $grey-color9, 500);
    &:before {
      content: " — ";
      margin-left: 4px;
      margin-right: 4px;
    }
  }
  &:first-child {
    border-top: 1px solid $grey-color3;
  }
}
.head-title {
  margin-left: 29px;
  margin-bottom: 26px;
}
.top-title {
  display: inline-block;
}
.icon-wrap {
  float: right;
  margin-right: 30px;
  margin-top: 6px;
  cursor: pointer;
  @include clearfix();
}
.all-entries {
  padding: 19px 31px 22px;
  @include font(13px, $grey-color9, 500);
  &__link {
    text-decoration: none;
    color: $red-color3 !important;
  }
  &_empty {
    border-top: 1px solid $white-color5;
    padding-top: 17px;
  }
}
@media only screen and (max-width : 370px) {
  .top-title {
    width: 170px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/NotificationsHistory.vue